import { cn } from "@/lib/chillnn/cn";

type Props = {
	type: "block" | "hidden";
	children: React.ReactNode;
};

export const PrintLayout = ({ type, children }: Props) => {
	const printStyle = type === "block" ? "hidden print:block" : "print:hidden";

	return <div className={cn(printStyle)}>{children}</div>;
};
